import React from 'react';

import {InlineBannerActionType, InlineBannerType} from 'ui-library/banners/InlineBanner';
import InlineBannerStack from 'ui-library/banners/InlineBannerStack';

import {
  InterfaceConstraintErrorDisplayDataForInterface,
  InterfaceConstraintErrorDisplayDataForSchema,
  SchemaInterfaceConstraintErrorType,
} from './validation/SchemaInterfaceValidationUtils';

export interface InterfaceConstraintErrorsBannerStackProps {
  interfaceConstraintErrors?:
    | Array<InterfaceConstraintErrorDisplayDataForSchema>
    | Array<InterfaceConstraintErrorDisplayDataForInterface>
    | null;
  onClickAction: (
    errorData: InterfaceConstraintErrorDisplayDataForInterface | InterfaceConstraintErrorDisplayDataForSchema
  ) => void;
  actionText: string;
  errorsToRender: Array<SchemaInterfaceConstraintErrorType>;
}

export default function InterfaceConstraintErrorsBannerStack(
  props: InterfaceConstraintErrorsBannerStackProps
): JSX.Element | null {
  if (props.interfaceConstraintErrors && Boolean(props.interfaceConstraintErrors.length)) {
    return (
      <InlineBannerStack
        messages={props.interfaceConstraintErrors
          .filter((errorData) => props.errorsToRender.includes(errorData.errorType))
          .map((errorData) =>
            errorData.id
              ? {
                  bannerType: InlineBannerType.ERROR,
                  text: errorData.error,
                  action: {
                    actionType: InlineBannerActionType.CUSTOM,
                    actionText: props.actionText,
                    actionOnClick: () => {
                      props.onClickAction(errorData);
                    },
                    rightAlign: true,
                  },
                }
              : {bannerType: InlineBannerType.ERROR, text: errorData.error}
          )}
      />
    );
  } else {
    return null;
  }
}
